module.exports = __webpack_public_path__ + "static/media/404.70d62784.svg";